import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";

export type CreateExpenseDescriptionFormValues = {
  name: string;
  expense_type_id: string;
  unit_id: string | null;
};

export type UpdateExpenseDescriptionFormValues = {
  id: string;
  is_reviewed?: boolean;
} & CreateExpenseDescriptionFormValues;

export const getExpenseDescriptions = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }

  const { data } = await axiosInstance.get("/expenses/descriptions", config);
  return data;
};

export const createExpenseDescription = async (
  data: CreateExpenseDescriptionFormValues
) => {
  const response = await axiosInstance.post("/expenses/descriptions", data);
  return response.data;
};

export const updateExpenseDescription = async (
  id: string,
  data: UpdateExpenseDescriptionFormValues
) => {
  const response = await axiosInstance.put(
    `/expenses/descriptions/${id}`,
    data
  );
  return response.data;
};

export const deleteExpenseDescription = async (id: string) => {
  const response = await axiosInstance.delete(`/expenses/descriptions/${id}`);
  return response.data;
};

export const restoreExpenseDescription = async (id: string) => {
  const response = await axiosInstance.post(
    `/expenses/descriptions/${id}/reactivate`
  );
  return response.data;
};
